// src/components/Dashboard/dashboardTable.ts
//
// Shared table metrics for the Outsourcing dashboards (EE-238). The two tables
// are built on different engines (hand-rolled state vs @tanstack/react-table),
// so they can't share a body component - but they can share the numbers, which
// is what drifted: the Inquiry skeleton ran at a ~46px pitch and the
// Requisition one at 54px.
export const SKELETON_ROW_HEIGHT = 30;

// --- Type scale -----------------------------------------------------------
//
// The Inquiry row used four sizes with nothing between them - 0.7, 0.75, 0.8
// and 0.9rem - picked per-cell rather than from a scale, so two cells showing
// the same kind of value disagreed. Three steps, by role:
//
//   PRIMARY   the one thing the cell is about
//   SECONDARY the qualifier that sits under it
//   MICRO     captions, empty states, type chips
export const ROW_FONT_PRIMARY = "0.875rem";
export const ROW_FONT_SECONDARY = "0.75rem";
export const ROW_FONT_MICRO = "0.6875rem";

// --- Spacing scale --------------------------------------------------------
//
// Replaces the hand-picked paddings in the row - 4.5rem and 2.5rem were
// holding columns apart that the table layout should have been spacing.
export const SP_1 = "4px";
export const SP_2 = "8px";
export const SP_3 = "16px";
export const SP_4 = "24px";

// A cell that stacks a primary value over a secondary one. Every cell in the
// Inquiry row is one of these, which is what makes the row scan as columns
// rather than as a paragraph per cell.
export const STACKED_CELL = {
  display: "flex",
  flexDirection: "column",
  lineHeight: 1.35,
  minWidth: 0,
} as const;

export const CELL_PRIMARY = {
  fontSize: ROW_FONT_PRIMARY,
  overflow: "hidden",
  textOverflow: "ellipsis",
} as const;

export const CELL_SECONDARY = {
  fontSize: ROW_FONT_SECONDARY,
  color: "var(--black75)",
  overflow: "hidden",
  textOverflow: "ellipsis",
} as const;
